import React from 'react';

const DownloadSettingFile: React.FC<{ data: any }> = ({ data }) => {
  const fileList: any[] = data?.financeSettingDocument || [];
  if (fileList.length > 0) {
    const file = fileList[0];
    const path = file.response.showPath;
    const name = file.name;
    return (
      <a href={path} download={name} target="_blank" rel="noreferrer">
        {name}
      </a>
    );
  } else {
    return <span>無檔案</span>;
  }
};

export default DownloadSettingFile;
